import { Analytics } from '@trello/atlassian-analytics';
import { featureFlagClient } from '@trello/feature-flag-client';

interface PerformanceMetric {
  name: string;
  totalTime: string;
}

interface PerformanceMetrics {
  /**
   * The array of metrics that should be sent
   */
  buffered: PerformanceMetric[];
  /**
   * A function used to clear the metrics buffer
   */
  flush: () => void;
}

/**
 * Sends the performance metrics to our metrics store, and then flushes
 * the metrics buffer
 */
export const flushPerformanceMetrics = ({
  buffered,
  flush,
}: PerformanceMetrics) => {
  const sendingEnabled = featureFlagClient.get(
    'fep.send-startup-performance-metrics',
    false,
  );
  if (!buffered || !flush || !sendingEnabled) {
    return;
  }

  for (const metric of buffered) {
    if (!metric.name || metric.totalTime === undefined) {
      return;
    }

    Analytics.sendOperationalEvent({
      action: 'measured',
      actionSubject: 'performance',
      source: 'appStartup',
      attributes: {
        name: metric.name,
        duration: metric.totalTime,
      },
    });
  }

  flush();
};
